import React, {useEffect, useState } from 'react';
import config from '../../../config';
import axios from 'axios';
import { Link } from 'react-router-dom';


const Service: React.FC = () => {

  // const [productArray, setProductArray] = useState<ProductArray[]>([]);
  const formatter = new Intl.NumberFormat('bn-BD');

  const fetchProductData = async () => {
    // try {
    //   const response = await axios.get<{ data: { data: ProductArray[] } }>(config.apiUrl+'product?size=100&page=1');
        
    //   if (response.status === 200) {
    //     setProductArray(response.data.data.data); 
    //     console.log('_product_list', response.data.data.data); 
    //   } else {
    //     console.error('Failed to fetch product data');
    //   }
    // } catch (error) {
    //   console.error('Error fetching product data:', error);
    // }
  };
  
  return (
    <div className="App">
        <div className="products my-sm-5 my-0 mb-5">
          <div className="container">
          <div className='search-area mt-3'>
            <span className='pe-3 d-block d-md-none mb-2 text-center'>হজযাত্রীর তথ্য যাচাই</span>
            <div className='input-group align-items-center flex-wrap flex-md-nowrap'>
              <span className='pe-3 d-none d-md-flex'>হজযাত্রীর তথ্য যাচাই</span>
              <input type="text" className='form-control' placeholder='আপনার তথ্য দিন ' />
              <button className='btn btn-white'><i className="fa-solid fa-magnifying-glass"></i></button>
            </div>
          </div>
          <h3 className="heading-text text-center mt-5">হজ-সংক্রান্ত সেবা</h3>
          <div className='mt-3'>
            <div className='row'>
              <div className='col-md-10 mx-auto'>
                <div className="row h-100 pb-4">
                  <div className='col-md-4 my-3 col-6'>
                    <div className="product-card h-100">
                      <div className="product-image">
                        <img src='./assets/img/products/pre-registration-icon.png' alt="not found" className='img-fluid' />
                      </div>
                      <div className="product-info">
                        <h5 className="product-title">প্রাক-নিবন্ধন</h5>
                      </div>
                      </div>
                  </div>
                  <div className='col-md-4 my-3 col-6'>
                    <div className="product-card h-100">
                      <div className="product-image">
                        <img src='./assets/img/products/pre-registration-icon.png' alt="not found" className='img-fluid' />
                      </div>
                      <div className="product-info">
                        <h5 className="product-title">নিবন্ধন</h5>
                      </div>
                      </div>
                  </div>
                  <div className='col-md-4 my-3 col-6 mx-auto'>
                    <div className="product-card h-100">
                      <div className="product-image">
                        <img src='./assets/img/products/pre-registration-icon.png' alt="not found" className='img-fluid' />
                      </div>
                      <div className="product-info">
                        <h5 className="product-title">পরবর্তী কার্যক্রম</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='my-5'>
            <div className='row'>
              <div className='col-md-10 mx-auto'>
                <div className='promotion-area'>
                  <div className='px-5 d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap'>
                    <div><h4 className='m-2 text-white'> ২০২৫</h4></div>
                    <div><p className='m-2 text-white'>সরকারি মাধ্যম = ৪,৯৭২ জন</p></div>
                    <div><p className='m-2 text-white'>বেসরকারি মাধ্যম = ৭৮,৯৬৮ জন</p></div>
                    <div><button className='btn btn-white'>আগের গুলি দেখুন</button></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
    </div>
  );
};

export default Service;
